/**
 * Whether a path is Box 44 - the list itself or anything inside it. Box 44 is edited in a modal rather
 * than a card, so both its label and the way to it differ from any other field.
 */
const isBox44Path = (path: string, box44Path?: string): box44Path is string =>
    !!box44Path && (path === box44Path || path.startsWith(`${box44Path}.`));

export default isBox44Path;
